import * as Category from '../Category';
import * as ABM from './ABM';
import * as Accounting from './Accounting';
import * as Analytics from './Analytics';
import * as Automation from './Automation';
import * as BrandProtection from './BrandProtection';
import * as CallCenter from './CallCenter';
import * as CMS from './CMS';
import * as CRM from './CRM';
import * as CustomerSuccess from './CustomerSuccess';
import * as DataManagement from './DataManagement';
import * as DropShipping from './DropShipping';
import * as ECommerce from './ECommerce';
import * as EMerchandising from './EMerchandising';
import * as Email from './Email';
import * as EmployeeEngagement from './EmployeeEngagement';
import * as ERP from './ERP';
import * as Event from './Event';
import * as FieldServiceManagement from './FieldServiceManagement';
import * as HelpDesk from './HelpDesk';
import * as IPaaS from './IPaaS';
import * as KnowledgeBase from './KnowledgeBase';
import * as LeadGen from './LeadGen';
import * as LearningManagementSystem from './LearningManagementSystem';
import * as LiveChat from './LiveChat';
import * as PartnerRelationshipManagement from './PartnerRelationshipManagement';
import * as PaymentGateways from './PaymentGateways';
import * as Payroll from './Payroll';
import * as Pos from './POS';
import * as PPC from './PPC';
import * as ProductReviews from './ProductReviews';
import * as Project from './Project';
import * as Sales from './Sales';
import * as Scheduling from './Scheduling';
import * as SEO from './SEO';
import * as ShoppingCart from './ShoppingCart';
import * as SMS from './SMS';
import * as Social from './Social';
import * as SubscriptionManagement from './SubscriptionManagement';
import * as Survey from './Survey';
import * as Ticketing from './Ticketing';
import * as Video from './Video';
import * as Webinar from './Webinar';
import * as Website from './Website';
import * as Wordpress from './Wordpress';
import * as Workflow from './Workflow';
export const BY_CATEGORY = {
  [Category.ABM]: ABM,
  [Category.ACCOUNTING]: Accounting,
  [Category.ANALYTICS]: Analytics,
  [Category.AUTOMATION]: Automation,
  [Category.BRAND_PROTECTION]: BrandProtection,
  [Category.CALL_CENTER]: CallCenter,
  [Category.CMS]: CMS,
  [Category.CRM]: CRM,
  [Category.CUSTOMER_SUCCESS]: CustomerSuccess,
  [Category.DATA_MANAGEMENT]: DataManagement,
  [Category.DROP_SHIPPING]: DropShipping,
  [Category.ECOMMERCE]: ECommerce,
  [Category.EMAIL]: Email,
  [Category.EMERCHANDISING]: EMerchandising,
  [Category.EMPLOYEE_ENGAGEMENT]: EmployeeEngagement,
  [Category.ERP]: ERP,
  [Category.EVENT]: Event,
  [Category.FIELD_SERVICE_MANAGEMENT]: FieldServiceManagement,
  [Category.HELP_DESK]: HelpDesk,
  [Category.IPAAS]: IPaaS,
  [Category.KNOWLEDGE_BASE]: KnowledgeBase,
  [Category.LEAD_GEN]: LeadGen,
  [Category.LEARNING_MANAGEMENT_SYSTEM]: LearningManagementSystem,
  [Category.LIVE_CHAT]: LiveChat,
  [Category.PARTNER_RELATIONSHIP_MANAGEMENT]: PartnerRelationshipManagement,
  [Category.PAYMENT_GATEWAYS]: PaymentGateways,
  [Category.PAYROLL]: Payroll,
  [Category.POS]: Pos,
  [Category.PPC]: PPC,
  [Category.PRODUCT_REVIEWS]: ProductReviews,
  [Category.PROJECT]: Project,
  [Category.SALES]: Sales,
  [Category.SCHEDULING]: Scheduling,
  [Category.SEO]: SEO,
  [Category.SHOPPING_CART]: ShoppingCart,
  [Category.SMS]: SMS,
  [Category.SOCIAL]: Social,
  [Category.SUBSCRIPTION_MANAGEMENT]: SubscriptionManagement,
  [Category.SURVEY]: Survey,
  [Category.TICKETING]: Ticketing,
  [Category.VIDEO]: Video,
  [Category.WEBINAR]: Webinar,
  [Category.WEBSITE]: Website,
  [Category.WORDPRESS]: Wordpress,
  [Category.WORKFLOW]: Workflow
};